export default {
      id: "down-usage",
      viewBox: "0 0 512 310",
      url: __webpack_public_path__ + "img/svg-sprite.svg#down",
      toString: function () {
        return this.url;
      }
    }